/**
 * 创建人：但志强
 * 时间：2019-6-11
 * 描述：下拉框单选组件
 * 使用说明: 参考 sw-select 配置应用说明文档
 * 更新记录: 
 * 1.新增输入属性 heigjt ,yuanjs by 2019-8-12 
 */
import { Component, OnInit, Input, forwardRef, Output, EventEmitter, ElementRef, Injector, ApplicationRef, ComponentFactoryResolver, ViewChild, SimpleChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormControl } from '@angular/forms';
import { DictionaryService } from 'src/app/librarys/serves/public/dictionary.service';
import { SwSelectBoxComponent } from './sw-select-box/sw-select-box.component';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { SwPinyinService } from './sw-pinyin.service';
declare var $;

export const EXE_COUNTER_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SwSelectComponent),
  multi: true
};
 
/**
 *  下拉框单选组件 sw-select
 */
@Component({
  selector: 'sw-select',
  providers: [EXE_COUNTER_VALUE_ACCESSOR],
  templateUrl: './sw-select.component.html',
  styleUrls: ['./sw-select.component.css']
})
export class SwSelectComponent implements OnInit {


  /**
   * select标签的类名
   */
  @Input() control: string = "form-control";

  /**
   * 传入的字典Key
   */
  @Input() dataKey: any;

  /**
   * 表单的value绑定
   */
  @Input() value: any;

  /**
   * 字典值显示的value
   */
  @Input() keyValue: string  = "dictionaryValue";

  /**
   * 字典值显示的value 
   */
  @Input() keyText: string  = "dictionaryName"

  /**
   * 传入的数据组
   */
  @Input() data: any = []; 

  /**
   * 是否显示清除按钮
   */
  @Input() clearData: boolean = true;

  /**
   * 下拉框的高度,不传默认根据内容自动设置
   */
  @Input() height: string = '250px'; 

  /**
   * 输出属性,下拉框选中某一项之后,将选中对象传递给父组件
   */
  @Output() changeClick = new EventEmitter();

 /**
   * 输出属性,清空后,将将清空值传递给父组件
   */
  @Output() clearClick = new EventEmitter();
  
  /**
   * 下拉框初始化时默认选中的项
   * @ignore  
   */
  @Input() _select: any;

  /**
   * 是否禁止操作 disabled
   */
  @Input() disabledValue: boolean = false;

  /**
   * 是否有搜索框
   */
  @Input() isSearch: boolean = false;

   /**
   * 未选中值时的提示
   */
  @Input() placeholder: string = '';

  /**
   * 是否可输入
   */
  @Input() isInput:  boolean = false;

   /**
   * 是否显示下拉图标 （一般显示 当disabledValue为true 且isDropmenuIcon为false时 隐藏下拉图标）
   */
  @Input() isDropmenuIcon:  boolean = true;

   /**
   * select输入框是否透明样式
   */
  @Input() transparent: boolean = false;
 /**
   * select输入框是否为样式2，且在左侧菜单列表內(true); 默认为false
   */
  @Input() isLefMenu: boolean = false;
  /**
   * select下拉框箭头 downArrow （即box显示的位置，下方down和右方right，默认为下方）
   */
  @Input() downArrow: string = 'down';
  /**
   * 1.select下拉框箭头向右，且为特殊样式类型2；2.默认类型为1; 3.（搜索下拉框、可汉字、全拼、简拼搜索）样式类型3
   */
  @Input() isStyle: string = '1';
  /**
  * isStyle样式类型为2 是否有返回按钮 默认false 没有
  */
  @Input() isBackBtn: boolean = false;
  /**
 * isStyle样式类型为2  且返回按钮isBackBtn为true
 */
  @Output() isBackEmit = new EventEmitter();
  /**
   * 选中的文本值
   * @ignore
   */
  selectText: string;

  /**
   * 输入的关键字
   * @ignore
   */
  keyword: string;


  /**
   * 展现关闭下拉
   * @ignore
   */
  dropdown: boolean = false;

  /**
   * 唯一Id
   * @ignore
   */
  ids: string;

    /**
   * 唯一Id
   * @ignore
   */
  idselect: string;

  /**
   * 搜索框的数据
   * @ignore
   */
  filter: any;

  /**
   * 用来判断Select的值来源 若来自输入框 则为true  若来自下拉框选中的 则为false
   * @ignore
  */
  isInputValue: boolean = false;
  /**
   * @ignore
   */
  get Select() {
    return this._select;
  }

  /**
 * @ignore
 */
  set Select(value: any) {
    if(!this.isInput){
      this.selectText = ''
    }
    this._select = value;
    this.propagateChange(this._select);
    //当为默认输入下拉框且还没输入时 （即初始化数据时）
    if(this.isInput && !this.isInputValue){
      this.getText()
    }
  }
  /**
   * @ignore
   */
  propagateChange = (_: any) => {
  };

  /**
   * 该方法用于将模型中的新值写入视图或 DOM 属性中。
   * @ignore
   */
  writeValue(value: any) {
    this.Select = value;
  }

  /**
   * 设置当控件接收到 change 事件后，调用的函数
   * @ignore
   */
  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }
  /**
   * 设置当控件接收到 touched 事件后，调用的函数
   * @ignore
   */
  registerOnTouched(fn: any) { }

  /**
   * @ignore
   * 定位width
   */
  @Input() width: string

  /**
   * @ignore
   * 定位left
   */
  left: string

  /**
   * @ignore
   * 定位top
   */
  top: string

  /**
   * @ignore
   */
  constructor(
    private dic: DictionaryService,
    private el: ElementRef,
    private injector: Injector,
    private applicationRef: ApplicationRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private box:SwMassageBoxService,
    private pinyin:SwPinyinService) {
  }

  @ViewChild('input') input:ElementRef;

  /**
   * @ignore
   */
  ngOnInit() {
    //创建唯一id
    this.ids = "select" + Math.random().toString().split(".")[1];
    this.idselect = "select" + Math.random().toString().split(".")[1];
    ///如果传递了Key则查找字典选项代替data
    if (this.dataKey) {
      this.data = this.dic.getDictionary(this.dataKey, this.keyValue, this.keyText);
    }
  }

  /**
   * 下拉框选中事件
   * @ignore
   */
  selectItem(event) {
    let item = { id: event.id, text: event.text };
    // 搜索内容
    this.selectText = event.text;
    // 选中的id
    this.Select = event.id;
    // 抛出
    this.changeClick.emit(item);
    //return false; //阻止事件冒泡而关闭下拉框
    //关闭下拉框
    this.dropdown = false;
    this.isInputValue = false;
  }


  swSelectComponentRef: any;
  /**
   * 打开下拉框
   * @ignore 
   */
  open(event) {
    //浏览器的高度
    let windowHeight = $(window).height()
    let position = this.el.nativeElement.getBoundingClientRect()
    // //创建dom节点
    const com = document.createElement(SwSelectBoxComponent.name);
    // //创建动态组件
    const factory = this.componentFactoryResolver.resolveComponentFactory(SwSelectBoxComponent);
    this.swSelectComponentRef = factory.create(this.injector, [], com);
    this.applicationRef.attachView(this.swSelectComponentRef.hostView);
    // 打开下拉框
    this.dropdown = true;
    // 向动态创建的组件传递参数
    this.swSelectComponentRef.instance['isStyle'] = this.isStyle;
    // 向动态创建的组件传递参数
    this.swSelectComponentRef.instance["downArrow"] = this.downArrow;
    // 向动态创建的组件传递参数
    this.swSelectComponentRef.instance["ids"] = this.ids;
    // 向动态创建的组件传递参数
    this.swSelectComponentRef.instance["elem"] = this.el;
    // 向动态创建的组件传递参数
    this.swSelectComponentRef.instance["disabledValue"] = this.disabledValue;
    // 向动态创建的组件传递参数
    this.swSelectComponentRef.instance["dropdown"] = this.dropdown;
    //当下拉框的方向向右且为样式类型2（左侧菜单的向右下拉框）
    if(this.downArrow == 'right' && this.isStyle == '2'){
      this.height = windowHeight -position.top + 'px'
    }
    // 向动态创建的组件传递参数
    this.swSelectComponentRef.instance["height"] = this.height;
    // 向动态创建的组件传递参数
    this.swSelectComponentRef.instance["isSearch"] = this.isSearch;
    // 向动态创建的组件传递参数
    if(this.isStyle == '3'){
      let das = this.data
      das.forEach(ele => {
        ele['pinyin'] = this.pinyin.getFullChars(ele.text)
        ele['lowPinyin'] = ele['pinyin'].toLowerCase()
        ele['camel'] = this.pinyin.getCamelChars(ele.text)
        ele['lowCamel'] = ele['camel'].toLowerCase()
      });
      this.swSelectComponentRef.instance["data"] = das;
    }else {
      this.swSelectComponentRef.instance["data"] = this.data;
    }
    

    this.swSelectComponentRef.instance["width"] = this.width;
    //向动态创建的组件传递参数 
    this.swSelectComponentRef.instance["isBackBtn"] = this.isBackBtn;
    // 向动态创建的组件传递回调函数
    this.swSelectComponentRef.instance["isBackEmit"].subscribe(data => {
      if (data) {
       this.isBackEmit.emit(true)
      }
    });
    // 向动态创建的组件传递回调函数
    this.swSelectComponentRef.instance["closeSelect"].subscribe(data => {
      // 是去焦点
      this.input.nativeElement.blur()
      if (data) {
        // 有参数就执行此方法
        this.selectItem(data);
      }
      try {
        // dom移除元素
        document.body.removeChild(com);
        this.applicationRef.detachView(this.swSelectComponentRef.hostView);
        // 销毁组件
        this.swSelectComponentRef.destroy()
      } catch (e) { }

    });
    // 将组件加到dom中去
    document.body.appendChild(com);
  }

  /**
   * @ignore
   * 关闭下拉框
   */
  close() {
    this.swSelectComponentRef.instance.close()

    //this.dropdown = false;
  }

  /**
   * 清空选中
   * @ignore
   */
  clearSelect() {
    this.Select = "";
    this.selectText = "";
    this.clearClick.emit(null)
    //若为搜索输入下拉框 则需要清空filter的值
    if(this.isInput && this.dropdown) {
      this.swSelectComponentRef.instance["filter"] = '';
    }
  }



  /**
   * 转换选中的数据
   * @ignore
   */
  getText() {

    if(this.value){
      return this.value;
    }
    if (this._select !== null && this._select !== undefined && this._select !== '' && this.data && this.data.length > 0) {
      let item = this.data.find(x => x.id == this._select)
      //为下拉搜索、或普通下拉框 (不包括下拉搜索输入功能)
      if(!this.isInput) {
         if(item) {
          this.selectText = item.text;
         }
      }else {
        //为下拉搜索输入功能 (不包括下拉搜索、或普通下拉框)
        if(item) {
          //若有和data匹配的值 但此时为输入状态 则为输入值
          if(this.isInputValue) {
           this.selectText = this.Select;
          }else {
            //若有和data匹配的值 且不为输入状态 则为选中的值
            this.selectText = item.text;
          }
        }else {
          //若没有和data匹配的值 则为输入的值
           this.selectText = this.Select;
        }

      }
    }
    return this.selectText;
  }

  /**
   * 下拉输入框时 赋值给Select 同步更新下拉框的filter 
   */
  changeInput(value) {
    this.Select = value
    if(this.isInput && this.dropdown) {
      this.isInputValue = true;
      this.swSelectComponentRef.instance["filter"] = value;
    }
  }

  //点击右侧三角图标,一定会先触发 blur , 不管原来有没有下拉框,点击之后一定没有了, 所以只需要原来没有就展开就行
  switchDropmenu(event){
    event.stopPropagation(); //禁止冒泡
    if(!this.dropdown){ 
      //如果this.dropdown 为false,说明没有展开下拉框,此时需要展开下拉框
      this.input.nativeElement.focus()
    }  else {
      //此时已经自动触发了 blur 事件,下拉框已销毁, 需要将 this.dropdown 设置为false
      this.dropdown = false
    }
  }
}
